// extracted by mini-css-extract-plugin
export default {"driftZoomBreakpoint":"768px"};